"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAuthentication = checkAuthentication;
exports.login = login;
exports.logout = logout;
exports.findTImeout = findTImeout;

var _EntitlementService = require("cornerstone_ui_core/lib/services/EntitlementService");

var _Timeout = _interopRequireDefault(require("cornerstone_ui_core/lib/services/Timeout.service"));

var _baseLayout = require("./base-layout.service");

var _utils = require("cornerstone_ui_core/lib//utils");

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function checkAuthentication() {
  return _checkAuthentication.apply(this, arguments);
}

function _checkAuthentication() {
  _checkAuthentication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var cacheKey, decoded, userid, appName, baseURL, data, jwtToken, subCacheKey, useFormat, modifiedCacheKey, _data, _jwtToken, subUserId, _useFormat, modifiedUserId, logoutUrl;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cacheKey = localStorage.getItem("jwttknkey");
            decoded = decodedToken();
            appName = localStorage.getItem("AppId");
            baseURL = window.location.origin;

            if (!(cacheKey && cacheKey !== "undefined" && !baseURL.includes(".com"))) {
              _context.next = 22;
              break;
            }

            _context.prev = 5;
            _context.next = 8;
            return (0, _EntitlementService.findUserSession)({
              identifierKey: cacheKey
            });

          case 8:
            data = _context.sent;
            jwtToken = (0, _jwtDecode.default)(data.jwtToken);
            userid = jwtToken.sub;
            appName = jwtToken.App; //TODO : app specific key name is not required as each app has different urls

            if (appName === "RDS") {
              localStorage.setItem("rdsjwCacheKey", cacheKey);
              localStorage.setItem("rdsAppToken", data.jwtToken);
            }

            if (appName === "SCS") {
              localStorage.setItem("scsjwCacheKey", cacheKey);
              localStorage.setItem("scsAppToken", data.jwtToken);
            }

            if (appName === "GCS") {
              console.log("appName === GCS" + cacheKey);
              localStorage.setItem("gcsjwCacheKey", cacheKey);
              localStorage.setItem("gcsAppToken", data.jwtToken);
            }

            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);
            console.error(_context.t0);

          case 20:
            _context.next = 36;
            break;

          case 22:
            if (!(cacheKey && cacheKey !== "undefined" && cacheKey !== undefined && baseURL.includes(".com"))) {
              _context.next = 35;
              break;
            }

            subCacheKey = cacheKey.split("\\");
            useFormat = "\\\\";
            modifiedCacheKey = subCacheKey[0] + useFormat + subCacheKey[1];
            console.log("Supplier Net", cacheKey, useFormat, modifiedCacheKey);
            _context.next = 29;
            return (0, _baseLayout.getUserSessionService)(modifiedCacheKey);

          case 29:
            _data = _context.sent;
            _jwtToken = (0, _jwtDecode.default)(_data.jwtToken);
            userid = _jwtToken.sub;
            appName = _jwtToken.App;
            _context.next = 36;
            break;

          case 35:
            if (decoded) {
              userid = decoded && decoded.email ? decoded.email.split("@")[0] : null;
              appName = localStorage.getItem("AppId");
            }

          case 36:
            if (userid && appName && appName.length > 0 && !baseURL.includes(".com")) {
              this.props.findByUserAppAndFunctions(appName, userid);

              if (window.location.hostname.substring(0, 3) === "pds") {
                this.props.getPersonaUser(userid, appName);
              }
            } else if (userid && appName && appName.length > 0 && baseURL.includes(".com")) {
              if (decoded && decoded !== undefined && decoded !== "undefined") {
                subUserId = userid.split("\\");
                _useFormat = "\\\\";
                modifiedUserId = subUserId[0] + _useFormat + subUserId[1];
                console.log("Decoded", decoded);
                this.props.fetchJwttokenSN(modifiedUserId, appName, decoded);
              } else {
                clearToken(); // if (
                //   (baseURL === "scs.cornerstone-dev.elcompanies.net" ||
                //     window.location.hostname == "localhost") &&
                //   localStorage.getItem("AppId") === "SCS"
                // ) {
                //   return this.loginModal.open().then(async values => {
                //     this.setState({ renderTime: Date.now() });
                //   });
                // }

                logoutUrl = (0, _utils.masterUrl)() + "/logout";
                window.location.href = logoutUrl;
              }
            } else {
              logout();
            }

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[5, 17]]);
  }));
  return _checkAuthentication.apply(this, arguments);
}

function login() {
  window.location.href = (0, _utils.masterUrl)();
}
/** fetching timeout based on entitlements */


function findTImeout() {
  return _findTImeout.apply(this, arguments);
}

function _findTImeout() {
  _findTImeout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var baseURL, appId, timeout, _response$data$getApp, response;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            baseURL = window.location.origin;
            appId = localStorage.getItem("AppId");
            timeout = 15;

            if (baseURL.includes(".com")) {
              _context2.next = 9;
              break;
            }

            if (!appId) {
              _context2.next = 9;
              break;
            }

            _context2.next = 7;
            return _Timeout.default.getAppTimeout(appId);

          case 7:
            response = _context2.sent;
            timeout = (_response$data$getApp = response.data.getAppTimeOut) === null || _response$data$getApp === void 0 ? void 0 : _response$data$getApp.timeout;

          case 9:
            localStorage.setItem("timeout", timeout);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _findTImeout.apply(this, arguments);
}

function logout() {
  var baseURL = window.location.origin;
  if (localStorage.getItem("actionTrackingObject")) localStorage.removeItem("actionTrackingObject"); // remove action tracking portion

  if (!baseURL.includes(".com")) {
    clearToken();
    var logoutUrl = (0, _utils.masterUrl)() + "/applogout";
    window.location.href = logoutUrl;
  } else {
    clearToken();
    var logoutUrl = (0, _utils.masterUrl)() + "/logout";
    window.location.href = logoutUrl;
  }
}

function setToken(token) {
  localStorage.setItem("sessionId", token);
}

function getToken() {
  return localStorage.getItem("sessionId");
}

function clearToken() {
  localStorage.setItem("logout-triggered", "logout" + Math.random());
  sessionStorage.clear(); //TODO: Move all user session related data to session storage

  localStorage.removeItem("sessionId");
  localStorage.removeItem("jwtToken");
}

function decodedToken() {
  var token = getToken();
  if (token && token !== "undefined") return (0, _jwtDecode.default)(token);
}
/* eslint-disable import/prefer-default-export */